import { render } from "./C4Feedback.vue?vue&type=template&id=15058556"
import script from "./C4Feedback.vue?vue&type=script&lang=js"
export * from "./C4Feedback.vue?vue&type=script&lang=js"

import "./C4Feedback.vue?vue&type=style&index=0&id=15058556&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__